export default class Utils {

  static sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  static hexToRGB(hex, alpha) {
  
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
  
    if (alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  
    return `rgb(${r}, ${g}, ${b})`;
  }  

  static needWhiteText(background) {
    const r = parseInt(background.slice(1, 3), 16);
    const g = parseInt(background.slice(3, 5), 16);
    const b = parseInt(background.slice(5, 7), 16);

    if ((r + g + b) >= (255 * 3 / 2)) {
      return false; // color is light
    } 

    return true; // color is dark
  }
}



// WEBPACK FOOTER //
// ./src/Utils/Utils.js